import { MouseEvent } from "react";
import { Link, useLocation } from "react-router-dom";
import Luminode from "./svg/LuminodeLogo";

function LuminodeLogo() {
  const { pathname } = useLocation();

  // On the home page the logo scrolls back to the top; elsewhere it links home.
  function scrollToTop(e: MouseEvent<HTMLAnchorElement>) {
    if (pathname !== "/") return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <Link to="/" onClick={scrollToTop}>
      <div className="text-white flex flex-row gap-4 items-center text-[18px] tracking-tight w-[154px]">
        <Luminode />
        Luminode
      </div>
    </Link>
  );
}

export default LuminodeLogo;
